(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8556],{

/***/ 293992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DigitalShowroomAds_ReasonModalHOC; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
;// CONCATENATED MODULE: ./src/utils/useClosePopupFromOutsideClick.js

function useClosePopupFromOutsideClick(referenceToDomElement, toggleClose, props) {
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        var ref;
        if (!((ref = e.composedPath()) === null || ref === void 0 ? void 0 : ref.includes(referenceToDomElement.current))) {
            e.stopPropagation();
            toggleClose(props === null || props === void 0 ? void 0 : props.id, props === null || props === void 0 ? void 0 : props.toggleStatus);
        }
    };
}
/* harmony default export */ var utils_useClosePopupFromOutsideClick = (useClosePopupFromOutsideClick);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(307297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(150066);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModal.styles.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0;\n  width: 20px;\n  margin-left: ",
        "rem;\n  transform: rotateZ(180deg);\n  margin-top: ",
        "rem;\n  box-shadow: 0px -6px 12px 2px rgb(0 0 0 / 30%);\n  ",
        ";\n\n  &:before {\n    content: '';\n    border-top: 10px solid white;\n    border-right: 10px solid transparent;\n    border-left: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var PointingArrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "PointingArrow",
    componentId: "sc-6444d3ae-0"
})(_templateObject(), function(props) {
    return props.ml || 0;
}, function(props) {
    return props.mt || 0;
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.translateX) && (props === null || props === void 0 ? void 0 : props.translateY) && "transform : translate(".concat(props === null || props === void 0 ? void 0 : props.translateX, "rem , ").concat(props === null || props === void 0 ? void 0 : props.translateY, "rem) rotate(180deg)");
});

;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js





function ReasonModalHOC(props) {
    var elementReferenceForOutsideClick = (0,react.useRef)();
    var closePopupForParticularId = {
        id: props.id,
        toggleStatus: false
    };
    utils_useClosePopupFromOutsideClick(elementReferenceForOutsideClick, props.toggleAdReasonModal, closePopupForParticularId);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PointingArrow, {
                ml: props.ml,
                translateX: props.translateX,
                translateY: props.translateY,
                mt: props.mt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    zIndex: 1
                },
                ref: elementReferenceForOutsideClick,
                className: props.class,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(props.reasonModal, {})
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_ReasonModalHOC = (ReasonModalHOC);


/***/ }),

/***/ 818556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Footers_Footer1; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/utils/removeDsAdsRouteLink.js
var removeDsAdsRouteLink = __webpack_require__(295218);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/assets/svgExports/InfoIcon.js
var InfoIcon = __webpack_require__(467313);
;// CONCATENATED MODULE: ./src/assets/svgExports/FlagIcon.js

var FlagIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10.44",
        height: "10.462",
        viewBox: "0 0 10.44 10.462",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            id: "Page-1",
            transform: "translate(0 0.05)",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                id: "_037---Waypoint-Flag",
                "data-name": "037---Waypoint-Flag",
                transform: "translate(0 -0.05)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Shape",
                        d: "M2.644,19.49l.192-.054a.348.348,0,0,0,.241-.429l-2.2-7.87a.435.435,0,0,0-.536-.3l-.025.007a.435.435,0,0,0-.3.536l2.2,7.87a.348.348,0,0,0,.429.241Z",
                        transform: "translate(0 -9.042)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "Shape-2",
                        "data-name": "Shape",
                        d: "M15.693,5.9A8.333,8.333,0,0,1,13.777,4.58a.171.171,0,0,1-.049-.175A24.654,24.654,0,0,0,14.36,1.13c.022-.184-.077-.238-.182-.112C12.128,3.47,8.581.569,6.47,2.8a.719.719,0,0,1,.059.15L7.956,8.056c2.115-2.2,5.649.681,7.7-1.765.1-.126.124-.357.041-.393Z",
                        transform: "translate(-5.305 -0.95)"
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/url-search-params-polyfill/index.js
var url_search_params_polyfill = __webpack_require__(35449);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/components/DesignSystem/DigitalShowroomAds/MobileReasonModal.js


function MobileReasonModal(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex f12px pa18px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "top-section pb18px fw6",
                        children: "You are seeing this Ad because owner of this website is using the free version"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-between items-center pl18px pr18px black-90",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex f12px fw6",
                        children: [
                            "If you own this website ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "then you can remove this."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "f12px",
                        onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "remove-adsection pa12px fw7",
                            children: "Remove this Ad"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var DigitalShowroomAds_MobileReasonModal = (MobileReasonModal);

// EXTERNAL MODULE: ./src/components/DesignSystem/DigitalShowroomAds/ReasonModalHOC.js + 2 modules
var ReasonModalHOC = __webpack_require__(293992);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody6/Hybrid.styles.js
var Hybrid_styles = __webpack_require__(343955);
// EXTERNAL MODULE: ./src/utils/checkIfThemePreview.js
var checkIfThemePreview = __webpack_require__(115483);
// EXTERNAL MODULE: ./src/components/DesignSystem/NextImage/index.ts + 1 modules
var NextImage = __webpack_require__(527941);
;// CONCATENATED MODULE: ./src/components/BrandFooter/index.js














var BrandFooter = function(props) {
    var toggleAdReasonModal = function toggleAdReasonModal() {
        setShowAdInfo(!showAdInfo);
    };
    var renderMobileAds = function renderMobileAds() {
        var ref, ref1, ref2;
        return !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf && ((ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.non_premium_ad_url_mobile) && !(storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : ref1.is_demo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* AdContainer */.g1, {
                paddingTop: 30,
                paddingBottom: 30,
                backgroundColor: "#000000",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-column digital-showroom__ads w-100 ph3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-100 bg-black-90 mb6px",
                            onClick: function() {
                                return setShowAdInfo(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex f12px o-50 mb6px white-90",
                                    children: "Why I am seeing this"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "digital-showroom__ads_footermt_-2px ml6px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon/* InfoIcon */.s, {
                                        size: 16,
                                        secondaryColor: "#838383"
                                    })
                                })
                            ]
                        }),
                        showAdInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(ReasonModalHOC/* default */.Z, {
                            toggleAdReasonModal: toggleAdReasonModal,
                            reasonModal: DigitalShowroomAds_MobileReasonModal,
                            class: "mobile-reason-modal",
                            ml: -1.21,
                            mt: 1.45,
                            translateX: 9.35,
                            translateY: -2.25
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex gif-height pointer items-start",
                            onClick: removeDsAdsRouteLink/* removeDsAdsRouteLink */.k,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                                src: (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.non_premium_ad_url_mobile,
                                width: 630,
                                height: 187,
                                unoptimized: true
                            })
                        })
                    ]
                })
            })
        });
    };
    var ref, ref1, ref2, ref3, ref4;
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var ref5 = (0,react.useState)(false), showAdInfo = ref5[0], setShowAdInfo = ref5[1];
    var shouldHideDSLogo = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Footer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.config) === null || ref4 === void 0 ? void 0 : ref4.hide_ds_label;
    var isPreview = (0,checkIfThemePreview/* default */.Z)();
    var onPlayStoreIconClick = function() {
        window.open("https://download.digitalshowroom.app/download-cfe", "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "brand-footer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "brand-footer__wrapper text-links",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "brand-footer__linkText",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "brand-footer__linkText--href",
                            href: constants/* DS_TERMS_AND_CONDITIONS_URL */.gl,
                            target: "_blank",
                            rel: "noreferrer",
                            children: "View Terms & Conditions"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "brand-footer__linkText",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "brand-footer__linkText--href",
                            href: constants/* CANCELATION_AND_REFUND_POLICY_URL */.a6,
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Refunds & Cancellation"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "brand-footer__linkText flex flex-row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "brand-footer__linkText--href flex",
                            href: "https://forms.gle/E86rmFAD2GP9rL9f7",
                            target: "_blank",
                            rel: "noreferrer",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex pt2px mr6px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlagIcon, {})
                                }),
                                "Report Store"
                            ]
                        })
                    })
                ]
            }),
            renderMobileAds(),
            !shouldHideDSLogo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "brand-footer__wrapper bg-pure-black-color",
                onClick: onPlayStoreIconClick,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "brand-footer__fadeText",
                        children: "Online store created using"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "brand-footer__BrandIcon",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "https://cdn.dotpe.in/longtail/themes/8073865/au772GhR.webp",
                            loading: "lazy",
                            alt: "Brand App Logo"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_BrandFooter = (BrandFooter);

// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(811163);
// EXTERNAL MODULE: ./src/components/LogoutModal/index.js
var LogoutModal = __webpack_require__(821448);
// EXTERNAL MODULE: ./src/utils/excuteLogout.js
var excuteLogout = __webpack_require__(385126);
// EXTERNAL MODULE: ./src/utils/getCustomCtaText.js
var getCustomCtaText = __webpack_require__(336623);
// EXTERNAL MODULE: ./src/components/DesignSystem/Footers/FooterStorePolicies/index.js
var FooterStorePolicies = __webpack_require__(781059);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/redux/actions/storePolicies.js
var actions_storePolicies = __webpack_require__(849784);
// EXTERNAL MODULE: ./src/hooks/useStoreContactDetails.tsx
var useStoreContactDetails = __webpack_require__(299375);
;// CONCATENATED MODULE: ./src/components/FooterStoreInfo/index.js














var FooterStoreInfo = function(param) {
    var store = param.store, props = param.props;
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutConfirmation(!showLogoutConfirmation);
    };
    var renderLoginLogout = function renderLoginLogout() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "footer1-login-logout",
                onClick: toggleAuthModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer1-login-logout-button fw5 pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontSize: 12
                        },
                        children: (user === null || user === void 0 ? void 0 : user.isLogin) ? "Logout" : "Login"
                    })
                })
            })
        });
    };
    var authAndLogoutModal = function authAndLogoutModal() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: showLogoutConfirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal["default"], {
                toggleLogoutModal: toggleLogoutModal,
                executeLogout: excuteLogout/* executeLogout */.q,
                showLogoutConfirmation: showLogoutConfirmation
            })
        });
    };
    var renderSocialMediaProfileDetails = function renderSocialMediaProfileDetails() {
        var ref, ref1, ref2;
        if (!((ref = store.social_media_profile_details) === null || ref === void 0 ? void 0 : ref.media_count) || ((ref1 = store.social_media_profile_details) === null || ref1 === void 0 ? void 0 : ref1.media_count) < 1) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "footer-social-media-container",
            style: {
                marginTop: "-10px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                    style: {
                        marginBottom: "14px"
                    },
                    children: "Follow us here"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "social-media-section flex space-between",
                    style: {
                        gap: "16px"
                    },
                    children: (ref2 = store.social_media_profile_details) === null || ref2 === void 0 ? void 0 : ref2.media_detail.map(function(profile) {
                        return profile.profile_url !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "social-media-icon",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: profile.profile_url,
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: profile.image_url,
                                    alt: "".concat(profile === null || profile === void 0 ? void 0 : profile.name, " image"),
                                    height: 24,
                                    width: 24
                                })
                            })
                        }, profile.id) : null;
                    })
                })
            ]
        });
    };
    var ref, ref1, ref2, ref3;
    var ref4 = (0,es/* useSelector */.v9)(function(state) {
        return {
            user: state.userReducer,
            storePolicies: state.storePolicyReducer.data
        };
    }), user = ref4.user, storePolicies = ref4.storePolicies;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var ref5 = (0,react.useState)(false), showLogoutConfirmation = ref5[0], setShowLogoutConfirmation = ref5[1];
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var visitorLoginFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().visitorLoginFeatureStatus;
    var isVisitorLoginVisible = visitorLoginFeatureStatus === null || visitorLoginFeatureStatus === void 0 ? void 0 : visitorLoginFeatureStatus.isVisible;
    var storePhone = (0,useStoreContactDetails/* default */.Z)().storePhone;
    (0,react.useEffect)(function() {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !(storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length)) dispatch((0,actions_storePolicies/* getStorePolicies */.S)({
            store_id: storeData.store_id
        }));
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        storePolicies === null || storePolicies === void 0 ? void 0 : storePolicies.length
    ]);
    (0,react.useEffect)(function() {
        setShowLogoutConfirmation(false);
    }, [
        user === null || user === void 0 ? void 0 : user.isLogin
    ]);
    var toggleAuthModal = function() {
        if (user === null || user === void 0 ? void 0 : user.isLogin) {
            toggleLogoutModal();
        } else {
            var ref;
            router.push((0,routes.getRoute)(routes.PATH.ORDERS, store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        }
    };
    var onCallBtnClick = function() {
        window.open("tel:".concat(storePhone), "_self");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            authAndLogoutModal(),
            store && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "footerStoreInfo",
                style: {
                    backgroundImage: "url(https://cdn.dotpe.in/longtail/themes/8073865/hSOcrWvX.webp)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "footerStoreInfo__name",
                        children: store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: isVisitorLoginVisible && renderLoginLogout()
                    }),
                    store.address && (store === null || store === void 0 ? void 0 : (ref1 = store.address) === null || ref1 === void 0 ? void 0 : ref1.visibility) === 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                        className: "footerStoreInfo__address",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "address",
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/pwcAEsv4.webp"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: store === null || store === void 0 ? void 0 : store.address.address_1
                            })
                        ]
                    }),
                    !!storePhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "footerStoreInfo__phone",
                        onClick: onCallBtnClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "phone",
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/FfX9ZJn1.webp"
                            }),
                            storePhone
                        ]
                    }),
                    (store === null || store === void 0 ? void 0 : store.social_media_profile_details) && renderSocialMediaProfileDetails(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterStorePolicies/* FooterStorePolicies */.p, {
                        storePolicies: storePolicies,
                        path: routes.PATH.STORE_POLICIES
                    }),
                    !(props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.hidden_components) === null || ref3 === void 0 ? void 0 : ref3.payment_method_images_not_visible) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        style: {
                            display: "none"
                        },
                        className: "footerStoreInfo_paymentOption",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (0,getCustomCtaText/* default */.Z)("pay_after_cta")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/VT17Aw5E.webp",
                                alt: "payment options",
                                loading: "lazy"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_FooterStoreInfo = (FooterStoreInfo);

;// CONCATENATED MODULE: ./src/components/DesignSystem/Footers/Footer1/index.js





var Footer1 = function(props) {
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FooterStoreInfo, {
                store: storeData,
                props: props
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BrandFooter, {})
        ]
    });
};
/* harmony default export */ var Footers_Footer1 = (Footer1);


/***/ }),

/***/ 781059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ FooterStorePolicies; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186438);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27909);




var FooterStorePolicies = function(props) {
    return !props.storePolicies || props.storePolicies.length == 0 ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bottom_section), " flex flex-column items-center"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().store_policies), " flex justify-around w-100 f6"),
            children: props === null || props === void 0 ? void 0 : props.storePolicies.map(function(page) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    name: "page".concat(page.page_type),
                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer_nav),
                    onClick: function() {
                        return (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_2__/* .handleRouteChangesOnClick */ .Z)(props === null || props === void 0 ? void 0 : props.path, {
                            page_type: page.page_type
                        });
                    },
                    children: page.page_name
                }, page.id);
            })
        })
    });
};


/***/ }),

/***/ 343955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ListingHeading; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "X6": function() { return /* binding */ Heading; },
/* harmony export */   "Z5": function() { return /* binding */ AllCategorySection; },
/* harmony export */   "bu": function() { return /* binding */ AllCategoryButton; },
/* harmony export */   "g1": function() { return /* binding */ AdContainer; },
/* harmony export */   "rV": function() { return /* binding */ MiddleBodyAdWrapper; }
/* harmony export */ });
/* unused harmony export Listing */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(307297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(150066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n  width: ",
        ";\n  display: flex;\n  max-width: 1600px;\n  flex-direction: column;\n  height: auto;\n  box-sizing: border-box;\n  position: relative;\n  margin: 0 auto;\n  ",
        "\n  @media screen and (max-width: 767px) {\n    padding-top: 0;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  width: 100%;\n  font-size: 40px;\n  color: ",
        ";\n\n  @media screen and (min-width: 767px) {\n    font-size: 40px;\n    margin-bottom: 3rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 28px;\n    margin-bottom: 2rem;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 1000px;\n  display: grid;\n  grid-template-rows: auto;\n  justify-items: center;\n  box-sizing: border-box;\n  margin-bottom: 3rem;\n\n  @media screen and (min-width: 767px) {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n    row-gap: 2rem;\n    column-gap: 1.5rem;\n    padding: 0 2rem;\n  }\n\n  @media screen and (max-width: 766px) {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    row-gap: 1.5rem;\n    column-gap: 1rem;\n    padding: 0 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #000000;\n  font-weight: 600;\n  margin-bottom: 0.8rem;\n\n  @media screen and (min-width: 767px) {\n    font-size: 28px;\n    padding: 0 0;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 20px;\n    padding: 0 20px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  position: sticky;\n  bottom: 5%;\n  z-index: 5;\n  background: transparent;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  border-radius: 30px;\n  box-shadow: 0px 16px 36px #0000004a;\n  background: ",
        " 0% 0% no-repeat padding-box;\n  color: ",
        ";\n  cursor: pointer;\n\n  @media screen and (min-width: 767px) {\n    font-size: 18px;\n    padding: 16px 40px;\n  }\n\n  @media screen and (max-width: 766px) {\n    font-size: 14px;\n    padding: 14px 16px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  grid-column-start: 1;\n  grid-column-end: 3;\n  background: ",
        ";\n  padding-top: ",
        "px;\n  padding-bottom: ",
        "px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: row;\n  background: #fff;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}

function slideInAnimate() {
    return "\n    animation-name: slide-in;\n    animation-duration: 0.5s;\n    transform : translateX(50px);\n\n    @keyframes slide-in {\n      from {\n          transform : translateX(0px);\n      }\n      to {\n          transform : translateX(50px);\n      }\n    }\n    ";
}
function slideOutAnimate(trasnlationDist) {
    return "\n    animation-name: slide-out;\n    animation-duration: 0.50s;\n\n    @keyframes slide-out {\n      from {\n          transform : translateX(50px);\n      }\n      to {\n        transform : translateX(-".concat(trasnlationDist - 50, "px);\n      }\n    }\n    ");
}
var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    displayName: "Container",
    componentId: "sc-81fe99c9-0"
})(_templateObject(), function(props) {
    return props.isBuilderMobile ? "4rem 16px 2rem" : "4rem 0 2rem";
}, function(props) {
    return props.isBuilderMobile ? "100%" : "80%";
}, function(props) {
    return props.showFilterDrawer === null ? "" : props.showFilterDrawer ? slideInAnimate() : slideOutAnimate(props.trasnlationDist);
});
var Heading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    displayName: "Heading",
    componentId: "sc-81fe99c9-1"
})(_templateObject1(), function(props) {
    return props.fontColor || "#000000";
});
var Listing = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Listing",
    componentId: "sc-81fe99c9-2"
})(_templateObject2());
var ListingHeading = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    displayName: "ListingHeading",
    componentId: "sc-81fe99c9-3"
})(_templateObject3());
var AllCategorySection = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategorySection",
    componentId: "sc-81fe99c9-4"
})(_templateObject4());
var AllCategoryButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AllCategoryButton",
    componentId: "sc-81fe99c9-5"
})(_templateObject5(), function(props) {
    return props.backgroundColor || "#ffffff";
}, function(props) {
    return props.backgroundColor ? "#ffffff" : "#000000";
});
var AdContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "AdContainer",
    componentId: "sc-81fe99c9-6"
})(_templateObject6(), function(props) {
    return props.backgroundColor || "#FFFFFF";
}, function(props) {
    return props.paddingTop || 0;
}, function(props) {
    return props.paddingBottom || 0;
});
var MiddleBodyAdWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "MiddleBodyAdWrapper",
    componentId: "sc-81fe99c9-7"
})(_templateObject7());


/***/ }),

/***/ 527941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ NextImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(425675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/NextImage.tsx
// import React, { useState } from 'react';
// import Image, { ImageProps } from 'next/image';
// /* --- shimmer helpers --- */
// const toBase64 = (str: string) =>
//   typeof window === 'undefined' ? Buffer.from(str).toString('base64') : window.btoa(str);
// const shimmer = (w = 700, h = 475) => `
// <svg width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
//   <defs>
//     <linearGradient id="g">
//       <stop stop-color="#f6f7f8" offset="0%" />
//       <stop stop-color="#eaeaea" offset="50%" />
//       <stop stop-color="#f6f7f8" offset="100%" />
//     </linearGradient>
//   </defs>
//   <rect width="${w}" height="${h}" fill="#f6f7f8"/>
//   <rect id="r" width="${w}" height="${h}" fill="url(#g)">
//     <animateTransform attributeName="transform" attributeType="XML"
//       type="translate" from="-${w} 0" to="${w} 0" dur="1s" repeatCount="indefinite" />
//   </rect>
// </svg>`;
// const shimmerDataURL = (w?: number, h?: number) =>
//   `data:image/svg+xml;base64,${toBase64(shimmer(w ?? 700, h ?? 475))}`;
// /* --- typed props like your original component --- */
// type TNextImage<T extends boolean = false> = T extends true
//   ? { useDefaultHTMLTag: true } & React.ImgHTMLAttributes<HTMLImageElement>
//   : { useDefaultHTMLTag?: false } & ImageProps;
// /* --- main component --- */
// export default function NextImage<T extends boolean = false>(props: TNextImage<T>) {
//   const [normalImageLoaded, setNormalImageLoaded] = useState(false);
//   const [loaded, setLoaded] = useState(false);
//   // native <img> mode
//   if ((props as any).useDefaultHTMLTag) {
//     const {
//       onLoad,
//       style,
//       width = '100%',
//       height = '100%',
//       ...rest
//     } = props as any;
//     const handleLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
//       setNormalImageLoaded(true);
//       if (onLoad) onLoad(e);
//     };
//     // ensure wrapper reserves space; if width/height provided use them, fallback to a default height
//     const wrapperStyle: React.CSSProperties = {
//       display: 'inline-block',
//       position: 'relative',
//       overflow: 'hidden',
//       width: width ? (typeof width === 'number' ? `${width}px` : width) : undefined,
//       height: height ? (typeof height === 'number' ? `${height}px` : height) : undefined,
//       backgroundImage: !normalImageLoaded ? `url("${shimmerDataURL(16, 9)}")` : undefined,
//       backgroundSize: 'cover',
//       backgroundPosition: 'center',
//       ...((style as React.CSSProperties) || {}),
//     };
//     return (
//       <span style={wrapperStyle}>
//         <img
//           {...(rest as React.ImgHTMLAttributes<HTMLImageElement>)}
//           onLoad={handleLoad}
//         />
//       </span>
//     );
//   }
//   // next/image mode
//   const nextProps = props as ImageProps;
//   const { width, height, onLoadingComplete, style } = nextProps as any;
//   // compute small blurDataURL from shimmer (you can also pass a custom blurDataURL prop)
//   const blurData = shimmerDataURL(
//     typeof width === 'number' ? width : 700,
//     typeof height === 'number' ? height : 475
//   );
//   // wrapper ensures a placeholder background while the image is loading
//   const wrapperStyle: React.CSSProperties = {
//     position: nextProps.layout === 'fill' ? 'absolute' : 'relative',
//     display: 'block',
//     width:
//       nextProps.layout === 'fill'
//         ? '100%'
//         : width
//           ? typeof width === 'number'
//             ? `${width}px`
//             : width
//           : undefined,
//     height:
//       nextProps.layout === 'fill'
//         ? '100%'
//         : height
//           ? typeof height === 'number'
//             ? `${height}px`
//             : height
//           : undefined,
//     backgroundImage: !loaded ? `url("${blurData}")` : undefined,
//     backgroundSize: 'cover',
//     backgroundPosition: 'center',
//     ...((style as React.CSSProperties) || {}),
//   };
//   return (
//     <div style={wrapperStyle}>
//       <Image
//         {...nextProps}
//         // keep placeholder prop so Next shows blur if it can, but we also have wrapper background as fallback
//         placeholder="blur"
//         blurDataURL={blurData}
//         onLoadingComplete={(res) => {
//           setLoaded(true);
//           if (onLoadingComplete) onLoadingComplete(res);
//         }}
//       />
//     </div>
//   );
// }





function NextImage(props) {
    if (props.useDefaultHTMLTag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        unoptimized: true
    }));
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/index.ts



/***/ }),

/***/ 27909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ handleRouteChangesOnClick; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17247);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(540190);



var handleRouteChangesOnClick = function(routePath) {
    var additionalQuery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
        pathname: (0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)(routePath, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain),
        query: additionalQuery
    });
};


/***/ }),

/***/ 295218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ removeDsAdsRouteLink; }
/* harmony export */ });
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(913886);

function removeDsAdsRouteLink() {
    window.open(_constants__WEBPACK_IMPORTED_MODULE_0__/* .REDIRECT_DS_ADS_LINK.COMMON_REDIRECTION_LINK */ .gr.COMMON_REDIRECTION_LINK, "_blank");
}


/***/ }),

/***/ 186438:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bottom_section":"FooterStorePolicies_bottom_section__Q64j2","footer__bottom-text":"FooterStorePolicies_footer__bottom-text__Cfylc","policy-nav":"FooterStorePolicies_policy-nav__u8EJg","store_policies":"FooterStorePolicies_store_policies__hE_9r","footer_nav":"FooterStorePolicies_footer_nav__DLmtJ"};

/***/ })

}]);